// @ts-nocheck
import { FormFieldIcon, FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css, ThemeProps } from "styled-components";

// Original interface : ...\mobius\src\FormField\FormField.tsx
interface FormFieldStyleProps extends ThemeProps<BaseTheme> {
    _sizeVariant: FormFieldSizeVariant;
}

export const formInputStyles = () => {
    return css<FormFieldStyleProps>`
        vertical-align: top;

        + button {
            outline-offset: -${props => props.theme.focus?.width};
        }

        &:disabled {
            border-color: ${getColor("common.borderDark")};
            background-color: ${getColor("common.disabledLight")} !important; /* Force over the datepicker selector */
            color: ${getColor("text")};
            opacity: 1;

            + button ${FormFieldIcon} {
                background: transparent;
            }

            + ${IconWrapper} {
                background: transparent;
            }
        }

        ${({ _sizeVariant }) => {
            if (_sizeVariant) {
                return `
                    &:not([aria-describedby]):nth-last-child(2),
                    &[aria-describedby]:nth-last-child(3),
                    &[role="searchbox"] {
                        padding-right: ${sizeVariantValues[_sizeVariant].height - 2}px;
                    }
                `;
            }
        }};
    `;
};

export const quantityInputStyles = () => {
    return css`
        border-color: ${getColor("common.border")};
        padding: 0.5rem;
        text-align: center;
        width: ${pxToRem(50)};
    `;
};
